import { render, staticRenderFns } from "./GetQuote.vue?vue&type=template&id=67455a7a"
var script = {}
import style0 from "./GetQuote.vue?vue&type=style&index=0&id=67455a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports